import { fetchWithAuth } from "./fetchWithAuth";

// Session service for backend-managed session state
export interface SessionData {
  userId: string;
  currentHubId: string | null;
  currentHubName: string | null;
  sessionData: any;
}

export class SessionService {
  private static baseUrl = "/api/session";

  // Get current session
  static async getCurrentSession(): Promise<SessionData | null> {
    console.log("[SessionService] Fetching current session");

    const res = await fetchWithAuth(`${this.baseUrl}/current`, { 
      method: "GET",
      headers: { "Content-Type": "application/json" }
    });

    if (res.status === 401) {
      console.warn("[SessionService] 401 → No active session");
      return null;
    }

    if (!res.ok) {
      console.error("[SessionService] Failed to fetch session", res.status);
      return null;
    }

    const data = await res.json();
    console.log("[SessionService] Loaded session:", data);
    return data;
  }

  // Update current hub
  static async updateCurrentHub(hubId: string, hubName?: string): Promise<boolean> {
    console.log("[SessionService] updateCurrentHub →", hubId, hubName || "");

    const res = await fetchWithAuth(`${this.baseUrl}/current`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ currentHubId: hubId, hubName }),
    });

    if (res.status === 401) {
      console.warn("[SessionService] 401 updating hub → user not authenticated");
      return false;
    }

    if (!res.ok) {
      console.error("[SessionService] Failed to update hub:", res.status);
      return false;
    }

    console.log("[SessionService] Hub updated successfully");
    return true;
  }

  // Clear session
  static async clearSession(): Promise<boolean> {
    console.log("[SessionService] Clearing session");

    const res = await fetchWithAuth(`${this.baseUrl}/current`, { 
      method: "DELETE",
      headers: { "Content-Type": "application/json" }
    });

    if (!res.ok) {
      console.error("[SessionService] Failed to clear session:", res.status);
      return false;
    }

    console.log("[SessionService] Session cleared");
    return true;
  }

  // Keep old method for backward-compatibility
  static async setCurrentHub(hubId: string): Promise<boolean> {
    return this.updateCurrentHub(hubId);
  }
}
